export const OPTION_TYPES = {
  CHEAPEST: 'CHEAPEST',
  SPECIFIC_SLA: 'SPECIFIC_SLA'
};
